<div class="d-flex justify-content-between taskCreatedList">
  <div>
    <h2 class="f-16">Create New Task</h2>
  </div>
  <ng-container *ngIf="userPermission.includes('task.create') || userRole == 'master admin'">
    <div class="{{ isMobileDevice ? 'd-block' : 'd-flex' }} align-items-center justify-content-end">
      <button class="_cancel-btn mr-2" (click)="lmService.is_new_task = false; closeAddTask(true)">Close</button>
      <button class="mr-2 _outline-btn btn-sm" [class.disabled]="submit_btn_disabled" (click)="onSubmit('onlySave')">Save</button>
      <button
        class="mr-2 _primary-btn btn-sm {{ isMobileDevice ? 'mt-2' : '' }}"
        [class.disabled]="submit_btn_disabled"
        (click)="onSubmit('save')"
        *ngIf="lmService.tab_levels?.length === 1">
        Save & Close
      </button>
    </div>
  </ng-container>
</div>
<div class="pb-2 pt-2">
  <p class="form-error font-weight-bold cursor-pointer" *ngIf="numOfNotValidFields > 0" (click)="notDisplayRequiredMessage = false">
    You have {{ numOfNotValidFields }} notifications. Select to view.
  </p>
  <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
    <ul>
      <li class="pb-1 cursor-pointer" *ngFor="let message of requiredErrorMessages" (click)="ActivateTabIndexByError(message.field)">
        {{ message?.message | capitalizephrase }}
      </li>
    </ul>
  </div>
</div>
<div class="p-0">
  <div class="create-user-form">
    <form [formGroup]="createTaskForm" #createFormElement>
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group mb-2">
                <label for="title">Title <span title="Required">*</span></label>
                <input
                  type="text"
                  class="site-input"
                  formControlName="title"
                  [ngClass]="{ '_input-error': createTaskForm.controls['title'].hasError('required') && submitted }" />
              </div>
            </div>
            <div class="col-sm-6 taskSpendStatus">
              <div class="form-group mb-2" *ngIf="jobTypes">
                <label for="role">Task Type </label>
                <ng-select
                  formControlName="job_type_id"
                  [items]="jobTypes"
                  bindLabel="name"
                  bindValue="_id"
                  [clearable]="false"
                  [searchable]="true"
                  (change)="onJobType()"
                  placeholder="Select Job Type"
                  [readonly]="isJobTypeDisable"
                  [ngClass]="{ '_input-error': createTaskForm.controls['job_type_id'].hasError('required') && submitted }">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-6 mb-2 taskSpendStatus">
              <div class="form-group" *ngIf="taskStatuses">
                <label for="role">Task Status </label>
                <ng-select
                  formControlName="task_status_id"
                  [items]="taskStatuses"
                  [clearable]="false"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Select Status"
                  [ngClass]="{ '_input-error': createTaskForm.controls['task_status_id'].hasError('required') && submitted }">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-12 mb-4 leadStatus" *ngIf="showLeads">
              <div class="create-task-dropdown">
                <label for="assign">Lead</label>
                <ng-select
                  formControlName="lead_id"
                  [items]="leads"
                  bindLabel="full_name"
                  bindValue="_id"
                  [searchable]="true"
                  placeholder="Select Lead"
                  [ngClass]="{ '_input-error': createTaskForm.controls['lead_id'].hasError('required') && submitted }">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Select Module</label>
                <ng-select
                  formControlName="property_project_type"
                  [items]="dropdown_options"
                  bindLabel="name"
                  bindValue="value"
                  [searchable]="true"
                  placeholder="Select Module">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="priorities">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <p>Priority</p>
                  <p class="ypm-text-light f-10 ml-1 mt-1">Assign a priority for your task.</p>
                </div>
                <div class="{{ isMobileDevice ? 'd-block' : 'd-flex' }} align-items-start">
                  <div class="form-check py-2 px-1 pb-0" *ngFor="let priority of priorities">
                    <div class="p-field-radiobutton d-flex align-items-center">
                      <p-radioButton name="priority_id" [value]="priority._id" formControlName="priority_id"></p-radioButton>
                      <label for="priority_id" class="pl-2 f-10">{{ priority.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="create-task-dropdown col-lg-6"
              *ngIf="
                createTaskForm.controls['property_project_type'].value == 'properties' &&
                createTaskForm.controls['property_project_type'].value != 'other'
              ">
              <label for="assign">Property</label>
              <re-multiselect
                [module]="'property'"
                [truncate]="13"
                [selected_ids]="this.createTaskForm.controls['properties_id'].value"
                (onUpdate)="onUpdateMSelect($event, 'properties_id')"
                [placeholder]="'Select Property'"
                [isCreateNew]="false"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>

            <div
              class="create-task-dropdown col-sm-6"
              *ngIf="
                createTaskForm.controls['property_project_type'].value == 'property' &&
                createTaskForm.controls['property_project_type'].value != 'other'
              ">
              <label for="assign">Listing</label>
              <re-multiselect
                [module]="'listings'"
                [truncate]="13"
                [selected_ids]="this.createTaskForm.controls['property_id'].value"
                (onUpdate)="onUpdateMSelect($event, 'property_id')"
                [placeholder]="'Select Listing'"
                [isCreateNew]="false"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
            <div
              class="create-task-dropdown col-sm-6"
              *ngIf="
                createTaskForm.controls['property_project_type'].value == 'contact' &&
                createTaskForm.controls['property_project_type'].value != 'other'
              ">
              <label for="contact">Contact</label>
              <re-multiselect
                [module]="'contacts'"
                [truncate]="13"
                [selected_ids]="createTaskForm.controls['contact_id'].value"
                (onUpdate)="onUpdateMSelect($event, 'contact_id')"
                [placeholder]="'Select Contact'"
                [style]="{ width: '100%' }"
                (editRecord)="editRecord($event)"
                [isEmail]="true">
              </re-multiselect>
            </div>
            <div
              class="create-task-dropdown col-sm-3"
              *ngIf="
                createTaskForm.controls['property_project_type'].value == 'project' &&
                createTaskForm.controls['property_project_type'].value != 'other'
              ">
              <label for="project">Project</label>
              <re-multiselect
                [module]="'projects'"
                [truncate]="13"
                [selected_ids]="createTaskForm.controls['project_id'].value"
                (onUpdate)="onUpdateMSelect($event, 'project_id')"
                [placeholder]="'Select Project'"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
            <div
              class="create-task-dropdown col-sm-3"
              *ngIf="
                apartments?.length > 0 &&
                createTaskForm.controls['property_project_type'].value == 'project' &&
                createTaskForm.controls['property_project_type'].value != 'other'
              ">
              <label for="apartment">Lot</label>
              <ng-select
                formControlName="apartment_id"
                [items]="apartments"
                bindLabel="lot_name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Lot"
                [ngClass]="{ '_input-error': createTaskForm.controls['apartment_id'].hasError('required') && submitted }">
              </ng-select>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-2 mt-3">
              <label for="additionalcoments" class="mb-1">Notes</label>
              <textarea
                name="additionalcoments"
                formControlName="description"
                class="site-input block-tab"
                cols="20"
                rows="4"
                [ngClass]="{ '_input-error': createTaskForm.controls['description'].hasError('required') && submitted }"
                placeholder="Send a note to the Assignee">
              </textarea>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-2 mt-3">
              <input type="file" #logoInput (change)="onLogoSelect($event)" [hidden]="1" accept=".svg,image/*" multiple="true" />
              <button type="button" class="_outline-btn" (click)="logoInput.click()"><i class="pi pi-plus mr-2 f-10"></i> Add Files</button>
            </div>
            <div class="fonts-list logo" *ngIf="attachments?.length > 0">
              <div class="s-font mb-2 position-relative" *ngFor="let logo of attachments" style="max-width: 70px">
                <i class="pi pi-times" (click)="deleteLogo(logo)"></i>
                <img
                  *ngIf="logo?.file?.includes('https://remmi-xm.s3.ap-southeast-2.amazonaws.com/')"
                  [src]="logo?.file"
                  alt="logo.file"
                  class="img-fluid" />
                <img
                  *ngIf="!logo?.file?.includes('https://remmi-xm.s3.ap-southeast-2.amazonaws.com/')"
                  [src]="S3Path + logo?.file"
                  alt="logo.name"
                  class="img-fluid" />
              </div>
            </div>
            <div class="fonts-list" *ngIf="logoUrl?.length > 0">
              <div class="s-font mb-2 position-relative" *ngFor="let logo of logoUrl; let i = index" style="max-width: 70px">
                <i class="pi pi-times" (click)="logos.splice(i, 1); logoUrl.splice(i, 1)"></i>
                <img [src]="logo" alt="" class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label>Checklist</label>
              <div class="d-flex align-items-center mx-0">
                <input
                  type="text"
                  [(ngModel)]="newItem"
                  class="mr-2 site-input"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Add item in checklist"
                  style="margin-top: 2px" />
                <button class="_cancel-btn px-4 br-50" [disabled]="newItem === ''" (click)="addCheckListItem()">
                  {{ checkItemToEdit !== null ? 'Edit' : 'Add' }}
                </button>
              </div>
              <ul class="col-12 mb-2 checklist-list" cdkDropList (cdkDropListDropped)="drop($event)">
                <li *ngFor="let item of checkList; let i = index" cdkDrag class="mb-2">
                  <div class="p-field-radiobutton d-flex align-items-center">
                    <p-radioButton name="sale_type" [value]="item" [(ngModel)]="newItem" (click)="checkItemToEdit = i; newItem = item">
                    </p-radioButton>
                    <label for="sale_type" class="pl-2 f-10">{{ item }}</label>
                  </div>
                  <div class="checklist-actions position-relative d-flex">
                    <span class="x-icon icon-drag"></span>
                    <span class="pi pi-times close-icon" (click)="checkList.splice(i, 1); checkItemToEdit = null"></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group mb-2">
                <label for="duedate">Select Date <span title="Required">*</span></label>
                <div class="w-100 right-aligned">
                  <p-calendar
                    formControlName="due_date"
                    placeholder="dd/mm/yy"
                    [firstDayOfWeek]="1"
                    (onSelect)="formatDates($event, 'due_date')"
                    dateFormat="dd/mm/yy"
                    [minDate]="minDate"
                    [ngClass]="{ invalidCalendarField: createTaskForm.controls['due_date'].hasError('required') }">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="task_time form-group mb-2">
                <label for="role">Time</label>
                <ng-select formControlName="task_time" [items]="timer_options" [searchable]="true" placeholder="Select Timer"> </ng-select>
              </div>
            </div>
            <div class="col-sm-4 taskSpendStatus">
              <div class="form-group mb-2">
                <label for="role">Select Reminder</label>
                <ng-select
                  formControlName="reminder"
                  [items]="reminder_options"
                  [ngClass]="{ '_input-error': createTaskForm.controls['reminder'].hasError('required') && submitted }"
                  [searchable]="true"
                  placeholder="Select Reminder">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-3 taskSpendStatus mt-4">
              <div class="form-group mb-2">
                <div class="d-flex align-items-center">
                  <p-checkbox
                    [binary]="true"
                    inputId="binary"
                    [ngClass]="{ '_input-error': createTaskForm.controls['isRecurring'].hasError('required') && submitted }"
                    formControlName="isRecurring"></p-checkbox>
                  <p class="pl-1 resurcing">Recurring Task</p>
                </div>
              </div>
            </div>
            <div class="col-sm-3 taskSpendStatus mt-4">
              <div class="form-group mb-2">
                <div class="d-flex align-items-center">
                  <p-checkbox
                    [binary]="true"
                    inputId="binary"
                    [ngClass]="{ '_input-error': createTaskForm.controls['SaveToGoogleCalendar'].hasError('required') && submitted }"
                    formControlName="SaveToGoogleCalendar">
                  </p-checkbox>
                  <p class="pl-1" tooltipPosition="top" pTooltip="Create task on attached calendars of selected staff">Sync Calendar</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="createTaskForm.controls['isRecurring'].value">
              <div class="form-group mb-2">
                <label class="invisible">invisible</label>
                <ng-select
                  formControlName="recurringType"
                  [items]="[{ name: 'Weekly' }, { name: 'Monthly' }, { name: 'Yearly' }]"
                  bindLabel="name"
                  bindValue="name"
                  [searchable]="true"
                  placeholder="Select Recurring Type">
                </ng-select>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="createTaskForm.controls['recurringType'].value && createTaskForm.controls['isRecurring'].value">
              <div class="form-group mb-2">
                <label for="duedate">End Date</label>
                <div class="w-100 right-aligned">
                  <p-calendar placeholder="dd/mm/yy" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" (onSelect)="formatDates($event, 'recurringEnds')">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-4 mb-2">
                <div class="create-task-dropdown">
                  <label for="assign">Staff <span title="Required">*</span></label>
                  <ng-select
                    [items]="originalAssigns"
                    formControlName="assignedUsers"
                    [multiple]="true"
                    [searchable]="true"
                    bindLabel="full_name"
                    bindValue="_id"
                    placeholder="Select Assignee"
                    class="_selectMultiple"
                    [ngClass]="{ '_input-error': createTaskForm.controls['assignedUsers'].hasError('required') }">
                    <ng-template ng-option-tmp let-item="item">
                      <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <div class="d-flex align-items-center cursor-pointer px-1">
                        <i class="pi pi-times-circle" (click)="clearStaff(item?._id, 'staff')"></i>
                        <p class="ng-value-label ml-1" (click)="openRightModal(item, 'staff')">{{ item.full_name }}</p>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="col-sm-4 mb-2">
                <div class="create-task-dropdown">
                  <label for="assign">Select Team</label>
                  <re-multiselect
                    [module]="'teams'"
                    [truncate]="13"
                    [selected_ids]="this.createTaskForm.controls['assignedTeams'].value"
                    (onUpdate)="onUpdateMSelect($event, 'assignedTeams')"
                    [placeholder]="'Select Team'"
                    [isCreateNew]="false"
                    [style]="{ width: '100%' }">
                  </re-multiselect>
                </div>
              </div>
              <div class="col-sm-4 mb-2">
                <div class="create-task-dropdown">
                  <label for="assign">Parent Task</label>
                  <ng-select
                    formControlName="parent_id"
                    [items]="task_list"
                    bindLabel="task_title"
                    bindValue="_id"
                    [searchable]="true"
                    [multiple]="false"
                    placeholder="Parent Task"
                    [clearable]="false">
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2 mt-3">
          <p>Created: {{ created_date | date: 'dd/MM/yy' }}</p>
        </div>
        <div class="col-lg-10 {{ isMobileDevice ? 'mt-2' : '' }}">
          <ng-container *ngIf="userPermission.includes('task.create') || userRole == 'master admin'">
            <div class="{{ isMobileDevice ? 'd-block' : 'd-flex' }} align-items-center justify-content-end mb-3">
              <button class="_cancel-btn mr-2" style="font-size: 10px !important" (click)="lmService.is_new_task = false; closeAddTask(true)">
                Close
              </button>
              <button class="mr-2 _outline-btn btn-sm" [class.disabled]="submit_btn_disabled" (click)="onSubmit('onlySave')">Save</button>
              <button
                class="mr-2 _primary-btn btn-sm {{ isMobileDevice ? 'mt-2' : '' }}"
                [class.disabled]="submit_btn_disabled"
                (click)="onSubmit('save')"
                *ngIf="lmService.tab_levels?.length === 1">
                Save & Close
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</div>
